/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateEmailAttachmentDataScanStatusSchema = z.enum([
	'queued',
	'scanning',
	'clean',
	'infected',
	'error',
	'skipped',
])

export type CandidateEmailAttachmentDataScanStatusSchema = z.infer<typeof candidateEmailAttachmentDataScanStatusSchema>
